import { render } from "./studentLeaveRefuseApply.vue?vue&type=template&id=920334c8&scoped=true"
import script from "./studentLeaveRefuseApply.vue?vue&type=script&lang=js"
export * from "./studentLeaveRefuseApply.vue?vue&type=script&lang=js"

import "./studentLeaveRefuseApply.vue?vue&type=style&index=0&id=920334c8&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-920334c8"]])

export default __exports__